import React from "react";
import classnames from "classnames";
import styles from "./ProgressBar.module.scss";

export interface ProgressBarProps {
    /** Доля от 0 до 1; значения вне диапазона обрезаются */
    value: number;
    /** Превышение: заполнение на всю ширину со штриховкой и пометкой для скринридера */
    overflow?: boolean;
    /** Подпись для скринридера (aria-label) */
    label?: string;
    className?: string;
}

/** Доля в диапазоне [0, 1]; нечисловое значение считается нулём */
const clamp = (value: number) => (Number.isFinite(value) ? Math.min(1, Math.max(0, value)) : 0);

/**
 * Полоса прогресса (бюджет, исполнение). Превышение показано штриховкой, а не только цветом,
 * и озвучивается скринридеру словом «Превышение».
 */
export const ProgressBar = ({ value, overflow = false, label, className }: ProgressBarProps) => {
    const share = overflow ? 1 : clamp(value);

    return (
        <div
            className={classnames(styles.bar, { [styles.overflow]: overflow }, className)}
            role="progressbar"
            aria-label={label}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={Math.round(share * 100)}
        >
            <div className={styles.fill} style={{ width: `${share * 100}%` }} />
            {overflow && <span className={styles.srOnly}>Превышение</span>}
        </div>
    );
};
